var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lock-toggle', { unlocked: !_vm.value }],on:{"click":_vm.onClick}},[_c('icon',{attrs:{"name":_vm.state}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }